
























































import CommonBase from "../CommonBase";
import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import {RegReminderConfig, NotificationManagerStatus, BackgroundLocationPermission, GeofenceStatusCode} from "../../modules/models";

@Component
export default class RegreminderProblemDialog extends CommonBase {
    @Prop()
    regReminderConfig!: RegReminderConfig | null;
    @Prop()
    notificationManagerStatus!: NotificationManagerStatus | null;
    @Prop({default: false})
    fixing!: boolean;
    @Prop()
    reloadNeeded!: boolean;
    @Prop()
    backgroundLocationPermission!: BackgroundLocationPermission;

    opened = false;

    get isMissingBackgroundPermission() {
      return this.regReminderConfig?.statusCode === GeofenceStatusCode.MissingBackgroundPermission;
    }

    get regReminderConfigError(): string | null {
        return this.regReminderConfig && this.regReminderConfig.errorMessage || null;
    }

    get notificationStatusError(): string | null {
        return this.notificationManagerStatus && this.notificationManagerStatus.regreminderNotificationError() || null;
    }

    @Emit("at-fix-background-position")
    emitFixBackgroundPos() {
        this.opened = false;
    }

    @Emit("at-open-notification-settings")
    emitFixNotif() {
    }

    @Emit("at-status-reload")
    emitReload() {}

    @Watch("regReminderConfigError")
    onRegreminderErrorChanged() {
        this.maybeClose();
    }

    @Watch("notificationStatusError")
    onNotificationStatusErrorChanged() {
        this.maybeClose();
    }

    open() {
        if(this.reloadNeeded) {
            this.emitReload();
        } else {
            this.opened = true;
        }
    }

    maybeClose() {
        if(this.regReminderConfigError == null && this.notificationStatusError == null) {
            this.opened = false;
        }
    }
}
